<template>
  <Header12 />
  <div class="body">
    <section class="background-rose">
      <MenuTitle title="Offres d’emploi" srcImg="/images/pages/offre-emploi.jpg" backgroundSpan="span-background-red" />
    </section>
    <section>
      <Content />
    </section>
    <hr />
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Content from './content.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../MenuTitle";
useHead({
    title: 'EMCI : Offre d\'emploi',
    meta: [
        {
            name: 'description',
            content: ''
        }
    ]
})
</script>

<style scoped>
.body {
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }
}
</style>